import { Navigation } from 'swiper/modules';
import { Swiper, SwiperSlide } from 'swiper/react';
import 'swiper/css';
import 'swiper/css/navigation';

const images = {
	betatag: require('@/assets/images/main/ico_betatag.png'),
	accountancy1: require('@/assets/images/vod/img_vod_thumb_accountancy1.jpg'),
	accountancy2: require('@/assets/images/vod/img_vod_thumb_accountancy2.jpg'),
	basis1: require('@/assets/images/vod/img_vod_thumb_basis1.jpg'),
	basis2: require('@/assets/images/vod/img_vod_thumb_basis2.jpg'),
	basis3: require('@/assets/images/vod/img_vod_thumb_basis3.jpg'),
	basis4: require('@/assets/images/vod/img_vod_thumb_basis4.jpg'),
	basis5: require('@/assets/images/vod/img_vod_thumb_basis5.jpg'),
	basis6: require('@/assets/images/vod/img_vod_thumb_basis6.jpg'),
	basis7: require('@/assets/images/vod/img_vod_thumb_basis7.jpg'),
	apprDesc: require('@/assets/images/sub/img_function_bg_appr_desc.jpg'),
	accountancyDesc: require('@/assets/images/sub/img_function_bg_accountancy_desc.jpg'),
	transactionDesc: require('@/assets/images/sub/img_function_bg_transaction_desc.jpg'),
	b2bDesc: require('@/assets/images/sub/img_function_bg_b2b_info.png'),
	profitLoss: require('@/assets/images/sub/img_function_bg_profit_detail.png')
};

const basisSlides = [
	{ src: images.basis1, title: '우리 회사의 환경에 맞게 회계, 급여 업무 설정해보기 동영상 팝업 열림' },
	{ src: images.basis2, title: '회사정보 추가 및 로고, 인감등록 해보기 동영상 팝업 열림' },
	{ src: images.basis3, title: '사용자 등록 및 권한관리 동영상 팝업 열림' },
	{ src: images.basis4, title: '계정과목 추가 및 전기자료 등록 동영상 팝업 열림' },
	{ src: images.basis5, title: '외부기관연동하여 홈택스 자료수집 해보기 동영상 팝업 열림' },
	{ src: images.basis6, title: '인증서가 등록된 카드/금융사 일괄연동 동영상 팝업 열림' },
	{ src: images.basis7, title: '거래처정보, 품목정보 건별 등록 및 엑셀업로드 동영상 팝업 열림' }
];

const accountancySlides = [
	{ src: images.accountancy1, title: '거래수집 내역 전표처리 방법 매출세금계산서 전표처리 해보기 동영상 팝업 열림' },
	{ src: images.accountancy2, title: '매입매출전표 입력 해보기 거래명세서, 세금계산서 연동발행 동영상 팝업 열림' }
];

const MainSubContentListBox = () => {
	return (
		<ul>
			{/* 전자결재 */}
			<li className="sub-list">
				<div className="function-vod"></div>
				<div className="function-desc">
					<img src={images.apprDesc} alt="전자결재 상세" />
				</div>
				<div className="function-list">
					<div className="function-text">
						<strong className="title">문서상신</strong>
						<div className="intro-desc">
							<ul className="bullet-square">
								<li className="bullet">
									회사 규정에 맞게 커스터마이징된 결재 양식을 제공하며, 상황에 따라 결재선을 자유롭게 지정할 수
									있습니다.
								</li>
								<li className="bullet">
									참조 문서 및 첨부파일을 등록해 주요 의사결정 내용을 증빙 자료로 관리할 수 있습니다.
								</li>
								<li className="bullet">결재 문서는 옵션별 출력 기능을 제공해 보관 및 공유가 용이합니다.</li>
							</ul>
						</div>
					</div>
					<div className="function-text">
						<strong className="title">결재함</strong>
						<div className="intro-desc">
							<ul className="bullet-square">
								<li className="bullet">
									미결 문서 및 결재 대기 문서를 알림·이메일로 안내받아 빠르게 확인하고 처리할 수 있습니다.
								</li>
								<li className="bullet">
									승인·반려 처리 시 결재 사유를 입력할 수 있으며, 회사별로 온·오프 설정이 가능합니다.
								</li>
								<li className="bullet">
									전결 기능을 통해 휴가·외근 등 결재자 부재 시에도 지정된 전결자가 결재를 처리해 업무 공백을
									최소화합니다.
								</li>
							</ul>
						</div>
					</div>
					<div className="function-text">
						<strong className="title">양식관리</strong>
						<div className="intro-desc">
							<ul className="bullet-square">
								<li className="bullet">
									기업에서 보편적으로 사용하는 기본 결재 양식을 제공하여 별도 설정 없이 바로 사용할 수 있습니다. <br />
									(업무연동 : 6개 / 기본문서 30개)
								</li>
								<li className="bullet">
									양식별로 결재 유형을 구분하여 필수 결재라인을 지정할 수 있습니다. (필수 결재라인은 순서만 변경가능하고
									삭제는 불가합니다)
								</li>
								<li className="bullet">
									회사 규정에 맞게 등록한 결재 양식을 제공하며, 상황에 따라 결재선을 자유롭게 지정할 수 있습니다.
								</li>
							</ul>
						</div>
					</div>
					<div className="function-text">
						<strong className="title">이력관리</strong>
						<div className="intro-desc">
							<ul className="bullet-square">
								<li className="bullet">문서 작성부터 결재 완료까지의 모든 처리 이력을 단계별로 확인할 수 있습니다.</li>
								<li className="bullet">
									결재자별 승인·반려 내역과 처리 일시가 자동으로 기록되어 결재 과정의 투명성을 확보할 수 있습니다.
								</li>
								<li className="bullet">
									결재 완료 문서는 이력 기반으로 보관되어 사후 조회 및 내부 관리 자료로 활용할 수 있습니다.
								</li>
							</ul>
						</div>
					</div>
				</div>
			</li>
			{/* 경영보고서 */}
			<li className="sub-list">
				<div className="function-vod"></div>
				<div className="function-list">
					<div className="function-item">
						<img src={images.profitLoss} alt="손익지표 요약" />
						<div className="function-text">
							<strong className="title new">손익지표 요약</strong>
							<div className="intro-desc">
								<p className="font-600 desc-lead">
									손익지표 요약 리포트는 국내 최고 회계법인인 삼일회계법인과의 협업을 통해
									<br />
									개발되었으며, 회계사의 전문적인 리뷰가 반영되어 신뢰도 높은 경영 데이터를
									<br /> 제공합니다.
								</p>
								<ul className="bullet-square">
									<li className="bullet">
										축적된 데이터를 기반으로 최근 6개월간의 매출액, 판매관리비, 영업손익을
										<br /> 월별 그래프와 표 형태로 시각화하여 제공하며, 보고서 작성에 소요되는 시간을
										<br /> 줄이는 동시에 의사결정과 외부 커뮤니케이션에 바로 활용할 수 있는 수준의
										<br /> 정제된 분석 결과를 제공합니다.
									</li>
									<li className="bullet">
										손익지표 리포트를 통해 영업손익 변동의 원인이 매출 증감에 따른 영향인지,
										<br /> 판매관리비 변동에 따른 영향인지 명확히 구분하여 분석할 수 있으며,
										<br /> 이를 통해 단순한 손익 결과를 넘어 손익 구조와 흐름에 대한 인사이트를 제공하고,
										<br /> 보다 정교한 경영 의사결정을 지원합니다.
									</li>
								</ul>
								<p className="font14-400 desc-note">
									※ <span className="color-primary2">재무상태 요약, 현금흐름 요약, 주요지표 총괄 보고서</span>가
									순차적으로 확대 제공될 예정입니다.
								</p>
							</div>
						</div>
					</div>

					<div className="function-text">
						<strong className="title">사업관리</strong>
						<div className="intro-desc">
							<ul className="bullet-square">
								<li className="bullet">기간별 매출/매입내역에 대해 증빙유형별 상세내역을 확인할 수 있습니다.</li>
								<li className="bullet">
									매출/매입 비율 및 이익현황을 월별로 비교하고 전년 자료와도 비교하여 제공합니다.
								</li>
								<li className="bullet">기간별 입출금 현황, 계좌별 잔액을 파악할 수 있습니다.</li>
								<li className="bullet">
									외상매출, 외상매입에 대해 기간별 잔액을 파악하고 업체별 잔액도 한눈에 확인이 가능합니다.
								</li>
								<li className="bullet">
									매출원가, 판관비에 대한 비용파악이 가능하며 판관비는 항목별로 세부적으로 구분하여 확인이 가능합니다.
								</li>
							</ul>
						</div>
					</div>
					<div className="function-text">
						<strong className="title">전계좌 현황</strong>
						<div className="intro-desc">
							<ul className="bullet-square">
								<li className="bullet">
									연동 수집된 전 계좌의 잔액 및 예적금/대출/펀드/외화 등의 등록된 모든 계좌의 현황과 총 자산 대비 비율을
									제공합니다.
								</li>
								<li className="bullet">
									각각의 계좌 구분별 데이터를 집약하여 한 눈에 파악할 수 있도록 하였고 수집된 자료 기준 계좌의 연동
									개수, 현 잔액과 총액 대비 비율의 정보를 제공합니다
								</li>
								<li className="bullet">
									모든 매출 거래는 조회된 내역을 엑셀파일로 다운로드할 수 있고, 자동 분개 처리 및 분개 수정도 가능하며,
									일괄적용 기능을 통해 유형 혹은 계정 일괄 변경도 가능합니다.
								</li>
								<li className="bullet">
									매출 현금영수증과 신용카드는 소액 거래이거나 승인 건이 많을 수 있어서, 병합/분리 기능을 제공하며, 해당
									기능을 통해 효과적으로 관리하며 회계처리 시 가시성을 높일 수 있습니다.
								</li>
							</ul>
						</div>
					</div>
					<div className="function-text">
						<strong className="title">인사급여현황</strong>
						<div className="intro-desc">
							<ul className="bullet-square">
								<li className="bullet">
									매출대비 급여현황, 전년동월대비 급여 지급현황을 시각화된 데이터로 제공합니다.
								</li>
								<li className="bullet">기간별 입사자, 퇴사자 내역을 통해 사원현황 파악이 가능합니다.</li>
								<li className="bullet">공지사항 및 인사관련 세무일정을 제공합니다.</li>
							</ul>
						</div>
					</div>
					<div className="function-text">
						<strong className="title">재고현황</strong>
						<div className="intro-desc">
							<ul className="bullet-square">
								<li className="bullet">기간별 입고, 출고 요약현황을 제공함으로써 재고흐름 파악이 가능합니다.</li>
								<li className="bullet">거래처별, 품목별 매출순위, 이익률 순위를 일목요연하게 정리하여 제공합니다.</li>
								<li className="bullet">
									품목별 현재고량 및 예상필요수량을 제공하여 재고부족에 대해 사전관리가 가능합니다.
								</li>
							</ul>
						</div>
					</div>
				</div>
			</li>
			{/* 기초정보 */}
			<li className="sub-list">
				<div className="function-list">
					<div className="function-text">
						<strong className="title new">조직관리</strong>
						<div className="intro-desc">
							<ul className="bullet-square">
								<li className="bullet">
									사원대장과 연동된 상시근로자와 단기•외부 인력을 임시근로자로 구분해 체계적으로 관리할 수 있습니다.
								</li>
								<li className="bullet">
									근로자 정보변경, 부서정보 변경 이력을 적재하여, 조직 이동 내역 및 변동 현황을 확인할 수 있습니다.
								</li>
								<li className="bullet">
									최대 10레벨의 트리구조로 조직도를 형성할 수 있고, 상•하위 조직의 추가 및 이동을 드래그 앤 드롭
									방식으로 편리하게 제공합니다.
								</li>
								<li className="bullet">
									직급, 직책, 입사일 등 다양한 기준으로 부서원 정렬 방식을 설정해 내부 규정에 부합하게 설정 가능합니다.
								</li>
								<li className="bullet">
									직원별로 권한을 부여하거나, 권한 그룹을 설정하여 그룹 단위로 권한을 부여할 수 있습니다.
								</li>
							</ul>
						</div>
					</div>
					<div className="function-text">
						<strong className="title">정보 관리</strong>
						<div className="intro-desc">
							<ul className="bullet-square">
								<li className="bullet">세금계산서 작성 및 세금신고 시 필요한 회사 기본정보를 입력합니다.</li>
								<li className="bullet">
									수시로 발생하는 신규 거래처 정보는 개별등록 또는 엑셀일괄등록하기로 쉽게 등록이 가능합니다.
								</li>
								<li className="bullet">품목 정보의 등록을 개별 또는 엑셀 일괄 등록하기로 쉽게 등록이 가능합니다.</li>
								<li className="bullet">
									부동산임대(공급)정보 기능을 제공하며, 부동산 임대업을 하는 업종에서 건물 및 호실에 대한 계약정보를
									입력할 수 있습니다.
								</li>
								<li className="bullet">
									업계 최초 거래처 신용등급 제공 및 조회기능을 제공하여, 거래처 리스크 관리를 지원합니다.
								</li>
								<li className="bullet">기초정보&gt;거래처정보에서 확인 가능합니다.</li>
							</ul>
						</div>
					</div>
					<div className="function-text">
						<strong className="title">
							거래처 신용 정보 관리
							<br />
							(업계 최초! 국내 유일!)
						</strong>
						<div className="intro-desc">
							<ul className="bullet-square">
								<li className="bullet">
									나이스평가정보를 통해 수집된 거래처 신용등급을 22단계 구간으로 나누어 제공합니다.
								</li>
								<li className="bullet">
									최근 신용등급 변동일자, 변동 단계를 제공해드리며 조회된 거래처 일반개요 정보를 스텔라 거래처정보로
									업데이트 할 수 있습니다.
								</li>
								<li className="bullet">
									[기초정보]-[정보관리]-[거래처정보]에서 거래처 신용등급에 대한 정보를 확인하실 수 있습니다.
								</li>
							</ul>
						</div>
					</div>
					<div className="function-text">
						<strong className="title">프로젝트/현장정보 관리</strong>
						<div className="intro-desc">
							<ul className="bullet-square">
								<li className="bullet">
									프로젝트와 현장은 탭으로 구분되어 등록 가능하며, 각 프로젝트 또는 현장별로 거래를 입력하여 해당 건 별
									총 매출액과 사용된 비용 등을 따로 산출해 볼 수 있습니다.
								</li>
								<li className="bullet">
									신규등록과 수정, 삭제가 가능하며 등록된 프로젝트 및 현장 리스트를 다운로드하여 관리할 수 있습니다.
								</li>
							</ul>
						</div>
					</div>
					<div className="function-text">
						<strong className="title">연동정보 관리</strong>
						<div className="intro-desc">
							<ul className="bullet-square">
								<li className="bullet">
									홈택스, 금융사, 카드사, 여신금융협회, 4대보험공단을 연동하여 적격증빙을 자동으로 수집하고 손쉽게
									전표발행이 가능하도록 합니다.
								</li>
								<li className="bullet">공동인증서 등록을 통해 홈택스, 은행, 카드거래내역을 수집할 수 있습니다.</li>
								<li className="bullet">
									홈택스 연동을 통해 세금계산서, 계산서, 현금영수증 거래내역을 자동으로 수집할 수 있으며, 수집된 내역은
									거래수집 메뉴를 통해 자동전표처리가 가능합니다.
								</li>
								<li className="bullet">
									여신금융협회 연동을 통해 카드매출내역을 수집할 수 있으며, 수집된 내역은 거래수집 메뉴를 통해
									자동전표처리가 가능합니다.
								</li>
								<li className="bullet">
									카드사용내역, 은행계좌 입출금 내역은 공동인증서 및 ID/PW 를 통해 연동이 가능하며, 연동할 경우 거래수집
									메뉴를 통한 자동전표 처리와 금융관리 메뉴에서 상세내역에 대한 조회가 가능합니다.
								</li>
								<li className="bullet">
									4대보험정보연계센터는 공동인증서로 연동이 가능합니다. 연동할 경우 스텔라 서비스에 저장된 사원정보로
									직접 4대보험 취득신고, 상실신고, 피부양자취득신고가 가능합니다.
								</li>
								<li className="bullet">
									기업뱅킹연동: 금융사들과 직접 연동하여 스텔라에서 더 빠르고 정확한 이체 서비스를 이용할 수 있습니다.
								</li>
							</ul>
						</div>
					</div>
					<div className="function-text">
						<strong className="title">고정자산 관리</strong>
						<div className="intro-desc">
							<ul className="bullet-square">
								<li className="bullet">
									고정자산 정보 입력 시 신규등록 및 직접 입력도 가능하고, 전기자료를 당기로 이월할 수 있는 기능으로
									간편하게 관리가 가능합니다.
								</li>
								<li className="bullet">
									고정자산에 입력되면 바로 감가상각 금액을 확인할 수 있으며, 결산자료관리를 통해 감가상각비 반영이
									가능합니다.
								</li>
								<li className="bullet">
									미상각자산 감가상각명세서 및 양도자산 감가상각명세서 등의 자동생성과 조회 기능으로 자산의 가치변화
									추적 및 관리가 가능하도록 지원합니다.
								</li>
							</ul>
						</div>
					</div>
					<div className="function-text">
						<strong className="title new">업무용승용차 관리</strong>
						<div className="intro-desc">
							<ul className="bullet-square">
								<li className="bullet">
									업무용승용차를 등록하고 관리합니다. 차량명의, 보험기간 관리, 운행자 관리, 고정자산 연동 등을
									지원합니다.
								</li>
								<li className="bullet">
									차량별 운행일지를 작성할 수 있습니다. 수기 작성 및 엑셀 업로드가 가능하며 자주 가는 운행구간에 대한
									즐겨찾기 등록, 운행 기록 일괄 수정 및 복사, 마감 기능을 제공합니다.
								</li>
								<li className="bullet">
									비용 전표 입력 시 차량, 부서, 운행자를 설정하여 관리할 수 있습니다. 입력한 내역은 차량별 비용 현황,
									부서별 비용 현황, 사원별 비용 현황을 통해 한눈에 확인할 수 있습니다.
								</li>
							</ul>
						</div>
					</div>
					<div className="function-text">
						<strong className="title">계정과목 관리</strong>
						<div className="intro-desc">
							<ul className="bullet-square">
								<li className="bullet">
									기업회계기준에 따른 일반적인 계정과목은 기본적으로 제공되며, 각 기업의 특성에 따라 계정과목을
									코드체계에 따라 추가할 수 있습니다.
								</li>
								<li className="bullet">
									자산, 자본, 부채, 수익, 비용의 기본 계정 체계가 나뉘어져 있으며, 각 계정별로 하위계정 추가가
									가능합니다.
								</li>
								<li className="bullet">
									회계 기수 별로 회계연도를 관리할 수 있으며, 회사 최초 로그인 시 개업일을 입력하면 자동으로 현재
									회계기수와 회계연도를 생성해 주며, 필요에 따라 전기자료 등록도 가능합니다.
								</li>
							</ul>
						</div>
					</div>
					<div className="function-text">
						<strong className="title">사용자 관리</strong>
						<div className="intro-desc">
							<ul className="bullet-square">
								<li className="bullet">
									기본 관리자는 사용자의 권한을 수정 및 관리할 수 있으며, 사용자 등록은 기존 사원정보에서 혹은
									직접등록으로 여러 명 등록이 가능합니다.
								</li>
								<li className="bullet">
									관리자로부터 권한을 부여받은 사용자는 주어진 권한에 따라 특정 메뉴 혹은 전체 메뉴 사용이 가능합니다.
								</li>
							</ul>
						</div>
					</div>
					<div className="function-text">
						<strong className="title new">업무 관리</strong>
						<div className="intro-desc">
							<ul className="bullet-square">
								<li className="bullet">
									소수점 처리방법 및 메시지 발송용 번호설정, 보고서 결재라인 설정 등의 공통설정 및 원가계정체계,
									과세유형 추가 설정 등의 회계설정이 가능합니다.
								</li>
								<li className="bullet">
									회계업무 설정 시 원하는 원가계정으로 다중선택 하여 사용할 수 있으며, 설정된 주 사용 원가계정에
									해당하는 계정과목체계만 표시됩니다. 원가를 사용안함으로 설정할 경우 계정과목 검색 및 결산자료 입력에
									노출되지 않습니다.
								</li>
								<li className="bullet">
									급여업무 설정 기능을 통해 사원번호 부여 및 두루누리 지원 사업장 대상여부, 중소기업 취업소득세 감면
									사업장 대상여부, 직책/부서 등 설정이 가능합니다.
								</li>
								<li className="bullet">
									급여일 및 지급/공제항목에 대해 전표처리 시 분개되는 계정과목 설정, 공제항목 전표처리 설정 및
									적요/거래처 등록, 근로소득 간이세율, 각종 보험 공제여부, 퇴직금 등 설정이 가능합니다.
								</li>
								<li className="bullet">조직 관리에 필요한 정보 설정이 가능합니다.</li>
							</ul>
						</div>
					</div>
				</div>
			</li>
			{/* 거래수집 */}
			<li className="sub-list">
				<div className="function-vod"></div>
				<div className="function-desc">
					<img src={images.transactionDesc} alt="" />
				</div>
				<div className="function-list">
					<div className="function-text">
						<strong className="title new">
							영수증업로드
							<img src={images.betatag} />
						</strong>
						<div className="intro-desc">
							<ul className="bullet-square">
								<li className="bullet">
									전자적 증빙 수집이 어려운 비용은 그동안 영수증을 일일이 확인하며 수기 전표 처리로 오류와 재작업이
									빈번했죠? 파로스는 AI 및 OCR 기술로 영수증 이미지를 분석해 전표를 자동 생성합니다.
								</li>
								<li className="bullet">
									자동 수집이 어려운 개인결제·간이영수증도 영수증 업로드만으로 AI가 전표 생성과 계정과목을 추천해,
									사용자는 최종 검수만으로 정확하고 빠른 전표 처리가 가능합니다.
								</li>
								<li className="bullet">
									수작업 입력으로 발생하던 비용과 오류를 줄여 시스템 운영비를 절감하고, 다건 업로드·일괄 계정 처리로
									회계 업무 속도와 입력 품질을 동시에 향상합니다.
								</li>
								<li className="bullet">
									그동안 전산화가 어려웠던 증빙도 전자화하여 저장할 수 있어 감사·세무조사 시 증빙 근거를 즉시 제시하여
									즉시 대응할 수 있습니다.
								</li>
							</ul>
						</div>
					</div>
					<div className="function-text">
						<strong className="title">거래자동수집</strong>
						<div className="intro-desc">
							<ul className="bullet-square">
								<li className="bullet">
									클릭 한번으로 연동한 외부 기관별 적격 증빙 내역의 자료수집이 가능하며, 각 기관별 수집가능 범위에 따라
									최대 3개월까지 자료수집이 가능합니다.
								</li>
								<li className="bullet">
									홈택스 자료 수집 시 세금계산서, 현금 영수증 건수가 많을 경우는 조회 기간을 분할하여 수집할 수
									있습니다. (연말정산자료제공 시점 or 세금계산서 발행이 급증하는 시기 등)
								</li>
								<li className="bullet">
									거래자동수집과 동시에 바로 개별/일괄 전표발행이 가능하며, 차변/대변 계정과목 및 계정코드 자동 적용을
									제공하여 누구나 쉽게 전표발행이 가능합니다.
								</li>
							</ul>
						</div>
					</div>
					<div className="function-text">
						<strong className="title">매출 거래</strong>
						<div className="intro-desc">
							<ul className="bullet-square">
								<li className="bullet">
									매출거래 자동수집을 통해 수동 입력 오류를 방지하고 매출정보를 신속하게 처리하여 재무분석 및 예산관리에
									도움을 드립니다.
								</li>
								<li className="bullet">
									홈택스에서 수집된 매출 세금 계산서 및 현금 영수증 목록, 여신금융협회 연동을 통해 수집된 매출 신용카드
									내역을 조회할 수 있으며, 해당 화면에서 전표 발행이 가능합니다.
								</li>
								<li className="bullet">
									모든 매출 거래는 조회된 내역을 엑셀파일로 다운로드할 수 있고, 자동 분개 처리 및 분개 수정도 가능하며,
									일괄적용 기능을 통해 유형 혹은 계정 일괄 변경도 가능합니다.
								</li>
								<li className="bullet">
									매출 현금영수증과 신용카드는 소액 거래이거나 승인 건이 많을 수 있어서, 병합/분리 기능을 제공하며, 해당
									기능을 통해 효과적으로 관리하며 회계처리 시 가시성을 높일 수 있습니다.
								</li>
							</ul>
						</div>
					</div>
					<div className="function-text">
						<strong className="title">매입 거래</strong>
						<div className="intro-desc">
							<ul className="bullet-square">
								<li className="bullet">
									매입거래 및 주문, 수령 등의 정보를 자동으로 수집하여 기업의 구매 활동을 추적하며, 자동 수집을 통해
									정확한 매입 데이터를 기록하고 현금흐름 예측 등 효율적인 매입거래 관리를 가능하게 합니다.
								</li>
								<li className="bullet">
									홈택스에서 수집된 매입 세금 계산서 내역 및 현금 영수증 목록, 카드사 홈페이지에서 수집된 매입 신용카드
									내역을 조회하실 수 있으며, 해당 화면에서 전표 발행이 가능합니다.
								</li>
								<li className="bullet">
									모든 매입 거래는 조회된 내역을 엑셀파일로 다운로드할 수 있고, 자동 분개 처리 및 분개 수정도 가능하며,
									일괄적용 기능을 통해 유형 혹은 계정 일괄 변경도 가능합니다.
								</li>
							</ul>
						</div>
					</div>
					<div className="function-text">
						<strong className="title">계좌 거래</strong>
						<div className="intro-desc">
							<ul className="bullet-square">
								<li className="bullet">
									금융사 홈페이지 내 입/출금 거래 내역을 수집한 내역이 조회되며, 중복의심 내역을 제외처리 하거나 제외한
									내역을 복원할 수 있습니다.
								</li>
								<li className="bullet">
									입출금 내역 중 반복되는 거래 또는 거래처 입력이 불필요한 단순 경비 사용 내역을 일괄처리하여 전표발행이
									가능합니다.
								</li>
							</ul>
						</div>
					</div>
				</div>
			</li>
			{/* 회계관리 */}
			<li className="sub-list">
				{/* <div className="function-vod">
					<div className="title">
						<span className="font-bold">동영상</span>으로 쉽게 따라하기
					</div>
					<div className="vod-list">
						<div className="swiper-button-prev">
							<button className="category-btn btn-prev"></button>
						</div>
						<Swiper
							modules={[Navigation]}
							spaceBetween={16}
							slidesPerView={4}
							navigation={{
								nextEl: '.swiper-button-next',
								prevEl: '.swiper-button-prev'
							}}
							observer={true}
							observeParents={true}>
							{accountancySlides.map((slide, index) => (
								<SwiperSlide key={index}>
									<a data-index={index} title={slide.title}>
										<img src={slide.src} alt={`Slide ${index}`} />
									</a>
								</SwiperSlide>
							))}
						</Swiper>
						<div className="swiper-button-next">
							<button className="category-btn btn-next"></button>
						</div>
					</div>
				</div> */}
				<div className="function-desc">
					<img src={images.accountancyDesc} alt="" />
				</div>
				<div className="function-list">
					<div className="function-text">
						<strong className="title new beta">
							말만해 AI
							<img src={images.betatag} />
						</strong>
						<div className="intro-desc">
							<ul className="bullet-square">
								<li className="bullet">
									말만해 AI는 업계 최초로 LLM 기반 자연어 처리 기술을 활용한 챗봇형 전표 자동 생성 베타 서비스입니다.
								</li>
								<li className="bullet">
									일상적인 문장으로 거래 내용을 입력하면, AI가 거래일자, 금액, 결제수단 등을 분석해 전표를 자동
									생성합니다.
								</li>
								<li className="bullet">
									생성된 전표는 거래일자, 적요, 금액, 계정과목, 거래처명이 자동입력되며, 사용자가 확인·수정 후 저장할 수
									있습니다.
								</li>
								<li className="bullet">
									반복적이고 시간이 많이 소요되는 전표 입력 업무를 자동화함으로써 핵심 비즈니스 업무에 집중할 수
									있습니다.
								</li>
							</ul>
						</div>
					</div>
					<div className="function-text">
						<strong className="title">매입매출전표</strong>
						<div className="intro-desc">
							<ul className="bullet-square">
								<li className="bullet">
									회계 초보자를 위한 자동분개와 숙련자를 위한 직접분개 기능을 제공합니다. 거래처와 공급가, 품목 추가 등
									기본 정보 입력만으로 분개가 자동으로 생성됩니다.
								</li>
								<li className="bullet">
									자동수집된 매입매출 세금계산서, 각종 신용카드, 현금영수증 내역 및 직접 등록한 매입매출 내역이
									조회되며, 전체 전표 내역의 조회, 수정, 삭제, 일괄등록이 가능하고 작성된 매출전표로 세금계산서 및
									거래명세서 발행이 가능합니다.
								</li>
								<li className="bullet">
									매입매출전표 입력 시 동일한 거래가 반복되거나, 유사한 거래가 빈번한 경우를 위해 기 거래내역을 선택한
									후 복사하기 기능으로 편리한 사용이 가능합니다.
								</li>
								<li className="bullet">
									외화거래 입력 시에는 통화코드 및 환율정보 제공을 통해 편리하게 원화로 환산하여 입력이 가능합니다.
								</li>
							</ul>
						</div>
					</div>
					<div className="function-text">
						<strong className="title ai">일반(대체) 전표</strong>
						<div className="intro-desc">
							<ul className="bullet-square">
								<li className="bullet">
									자동수집한 내역 중 일반대체전표로 전표발행한 내역 및 직접 등록한 내역이 조회되며, 부가세신고와 무관한
									내역이 조회되는 메뉴입니다.
								</li>
								<li className="bullet">
									대부분의 스텔라 기능에서 제공하고 있는 일괄등록을 위한 엑셀 양식을 다운로드한 후 가이드에 따라 전표
									내용을 입력한 후 쉽고 빠르게 일괄등록이 가능합니다. 엑셀 업로드 된 내역은 수기 입력으로 조회됩니다.
								</li>
								<li className="bullet">
									외화거래 입력 시에는 통화코드 및 환율정보 제공을 통해 편리하게 원화로 환산하여 입력이 가능합니다.
								</li>
							</ul>
						</div>
					</div>
					<div className="function-text">
						<strong className="title">세금계산서 발행</strong>
						<div className="intro-desc">
							<ul className="bullet-square">
								<li className="bullet">
									일반/영세/면세 등 모든 과세 유형별 세금계산서를 발행할 수 있습니다. 발행한 세금계산서는 즉시발송 혹은
									익일 전송으로 선택이 가능하며, 익일 전송으로 발행된 세금계산서는 전송 전(발행당일)에 한하여 발행취소가
									가능합니다.
								</li>
								<li className="bullet">
									전자 발행한 세금계산서가 홈택스로 전송 완료되면 [홈택스 전송 후]탭에서 조회되며, 즉시전송으로 발행 한
									세금계산서는 즉시 홈택스로 전송되어 발행 취소는 불가 하며, 전송 완료 처리 후 수정 발행만 가능 합니다.
								</li>
								<li className="bullet">
									발행은 이메일/카카오톡/팩스 등 전자발행과 출력이 가능한 종이발행 모두 지원합니다.
								</li>
							</ul>
						</div>
					</div>
					<div className="function-text">
						<strong className="title">반제관리 (매출채권, 매입채무 잔액관리)</strong>
						<div className="intro-desc">
							<ul className="bullet-square">
								<li className="bullet">실제 입출금 내역과 연결하여, 손쉽게 반제 전표를 생성할 수 있습니다.</li>
								<li className="bullet">
									전표 생성 시 거래처별 반제 잔액을 확인하고, 반제할 거래를 선택해 처리할 수 있습니다.
								</li>
								<li className="bullet">전액반제, 부분반제, 초과반제를 모두 지원합니다.</li>
								<li className="bullet">반제처리 시 자동분개가 기본 제공되어 수작업 부담을 줄여줍니다.</li>
								<li className="bullet">채권 발생일 및 만기일을 기준으로 채권연령을 분석할 수 있습니다.</li>
							</ul>
						</div>
					</div>
					<div className="function-text">
						<strong className="title">기간수익/기간비용 관리</strong>
						<div className="intro-desc">
							<ul className="bullet-square">
								<li className="bullet">
									보험료, 임대료, 공사비처럼 한 번에 결제하지만, 실제로는 여러 달에 걸쳐 사용되는 비용에 대해 등록하고
									관리할 수 있도록 제공하는 기능이 ‘기간비용’ 입니다. 월별로 인식이 필요한 비용을 자동으로 계산하여 상각
									일정에 맞춰 매달 전표를 발행할 수 있어 누락 없이 회계처리할 수 있습니다.
								</li>
								<li className="bullet">
									반대로, 서비스 요금을 한 번에 청구하거나 수령했더라도, 실제 제공 기간에 맞춰 수익을 나눠서 인식해야
									하는 경우가 있습니다. 이럴 때 필요한 것이 바로 ‘기간수익’ 기능입니다. 회계상 이를 선수수익의
									인식이라고 하며, Stella는 이 복잡한 과정을 자동 계산 + 전표 처리로 간편하게 해결해드립니다.
								</li>
							</ul>
						</div>
					</div>
					<div className="function-text">
						<strong className="title">경영보고서</strong>
						<div className="intro-desc">
							<ul className="bullet-square">
								<li className="bullet">
									미수/미지급 보고서, 기간 손익보고서, 프로젝트별 손익보고서, 현장별 손익보고서, 부서별 손익보고서 등
									경영보고서가 자동으로 생성됩니다.
								</li>
								<li className="bullet">모든 보고서는 조회기간별 생성이 되며, 엑셀파일로 다운로드 가능합니다.</li>
							</ul>
						</div>
					</div>
					<div className="function-text">
						<strong className="title new">월간경영보고서</strong>
						<div className="intro-desc">
							<ul className="bullet-square">
								<li className="bullet">
									주요 재무 지표와 매출·현금 흐름 데이터를 대시보드 형태로 제공하여 월별 경영 성과를 직관적으로 파악할
									수 있습니다.
								</li>
								<li className="bullet">
									현금 잔액, 외상매출·외상매입, 영업이익 등 핵심 재무 지표와 월간 자금 수지 및 손익 추이를 한 화면에서
									확인할 수 있습니다.
								</li>
								<li className="bullet">
									월별·누적 매출 현황과 전월 대비 증감 정보를 시각화하여 재무 관리 및 실적 분석의 효율성을 높입니다
								</li>
							</ul>
						</div>
					</div>
					<div className="function-text">
						<strong className="title new">금융보고서</strong>
						<div className="intro-desc">
							<ul className="bullet-square">
								<li className="bullet">
									입력된 전표를 기준으로 전일잔액과 당일 증감에 대한 현황을 자금일보를 통해 확인 가능하며 엑셀파일로
									다운로드 가능합니다.
								</li>
								<li className="bullet">
									분개장, 계정별원장, 합계잔액시산표 기준으로 잔액이 조회되며, 기본적으로 일별 자금내역을 조회할 수
									있습니다.
								</li>
								<li className="bullet">
									예적금현황은 은행거래처의 계좌별로 예금, 적금의 거래내역 및 잔액을 조회하는 기능입니다.
								</li>
							</ul>
						</div>
					</div>
					<div className="function-text">
						<strong className="title new">어음관리</strong>
						<div className="intro-desc">
							<ul className="bullet-square">
								<li className="bullet">
									받을어음: 거래처로부터 수취한 어음을 체계적으로 관리하기 위해 어음 상태, 어음 번호, 발행인, 만기일,
									배서 여부, 회수 상태 등을 전표 입력 시 추가로 입력할 수 있습니다.
								</li>
								<li className="bullet">
									지급어음: 외상 구매 등으로 발행한 어음을 관리하기 위해 어음 번호, 발행인, 만기일, 지급은행, 어음 종류
									등 어음 발행 관련 정보를 입력할 수 있게 됩니다.
								</li>
								<li className="bullet">
									당좌예금: 기업이 보유한 은행의 당좌 계좌를 관리하기 위해 수표 번호, 발행일, 만기일 등을 전표 입력 시
									연결하여 관리할 수 있습니다.
								</li>
							</ul>
						</div>
					</div>
				</div>
			</li>
			{/* 금융관리 */}
			<li className="sub-list">
				<div className="function-vod"></div>
				<div className="function-list">
					<div className="function-text">
						<strong className="title">대시보드</strong>
						<div className="intro-desc">
							<ul className="bullet-square">
								<li className="bullet">
									연동 수집된 전 계좌의 잔액 및 예적금/대출/펀드/외화 등의 등록된 모든 계좌의 현황과 총 자산 대비 비율을
									제공합니다.
								</li>
								<li className="bullet">
									각각의 계좌 구분별 데이터를 집약하여 한 눈에 파악할 수 있도록 하였고 수집된 자료 기준 계좌의 연동
									개수, 현 잔액과 총액 대비 비율의 정보를 제공합니다.
								</li>
							</ul>
						</div>
					</div>
					<div className="function-text">
						<strong className="title">거래내역 조회</strong>
						<div className="intro-desc">
							<ul className="bullet-square">
								<li className="bullet">
									계좌거래내역: 자료수집에서 수집된 은행계좌 정보를 기반으로 주요 입출금 데이터를 쉽게 파악할 수 있도록
									도와주며, 대시보드 형태로 유용한 자금 관리 데이터를 제공합니다.
								</li>
								<li className="bullet">
									카드사용내역: 외부기관연동에서 연동한 카드사의 자료를 기준으로 조회되며, 월 누적금액 및 월 청구금액,
									일별 카드 사용현황, 전월대비 추이 등 유용한 데이터를 제공합니다.
								</li>
							</ul>
						</div>
					</div>
					<div className="function-text">
						<strong className="title">이체결과</strong>
						<div className="intro-desc">
							<ul className="bullet-square">
								<li className="bullet">
									이체 유형별로 이체결과를 월단위로 한번에 검색 및 확인할 수 있으며, 이체실패 건수 및 금액을 확인할 수
									있습니다.
								</li>
							</ul>
						</div>
					</div>
					<div className="function-text">
						<strong className="title">일반이체</strong>
						<div className="intro-desc">
							<ul className="bullet-square">
								<li className="bullet">등록된 출금계좌를 선택하여 전표입력 없이도 일반이체가 가능합니다.</li>
								<li className="bullet">기업용 계좌는 다건 이체가 가능하며, 개인용은 단건 이체만 가능합니다.</li>
								<li className="bullet">
									입출금 계좌를 자유롭게 입력할 수 있고, 예금주 조회 기능 적용으로 착오 입금 여부를 사전에 확인
									가능합니다.
								</li>
							</ul>
						</div>
					</div>
					<div className="function-text">
						<strong className="title">집금이체(돈 모으기)</strong>
						<div className="intro-desc">
							<ul className="bullet-square">
								<li className="bullet">
									여러 계좌에 분산된 기업자금을 편리하게 모 계좌로 이체하여 모아서 관리하도록 하는 집금이체 기능을
									제공합니다.
								</li>
								<li className="bullet">출금계좌별 잔액조회 및 집금 총액, 집금 실행을 간편하게 이용할 수 있습니다.</li>
								<li className="bullet">이체 전 이체정보를 포함한 지출결의서 자동생성 및 출력물을 제공합니다.</li>
							</ul>
						</div>
					</div>
					<div className="function-text">
						<strong className="title">대금이체</strong>
						<div className="intro-desc">
							<ul className="bullet-square">
								<li className="bullet">
									매입전표로 구분되는 거래 대금을 이체할 수 있으며, 증빙유형이 세금계산서인 내역 중에서 대변이
									외상매입금 또는 미지급금으로 입력된 거래 내역의 리스트를 조회하고 선택하여 해당 거래를 이체할 수
									있습니다.
								</li>
								<li className="bullet">이체와 함께 지출결의서 작성도 가능하며 월단위로 내역을 조회할 수 있습니다.</li>
							</ul>
						</div>
					</div>
					<div className="function-text">
						<strong className="title">급여이체</strong>
						<div className="intro-desc">
							<ul className="bullet-square">
								<li className="bullet">
									기본적으로 기업 공동인증서 연동 후 이체가 가능하며, 사원별로 등록된 급여 이체가 가능합니다. 전체
									합계건수 및 이체 완료 건수, 이체 미완료 건수, 실지급액 합계를 확인할 수 있습니다.
								</li>
								<li className="bullet">이체와 함께 지출결의서 작성도 가능하며 월단위로 내역을 조회할 수 있습니다.</li>
							</ul>
						</div>
					</div>
					<div className="function-text">
						<strong className="title">지출결의서</strong>
						<div className="intro-desc">
							<ul className="bullet-square">
								<li className="bullet">
									이체 유형별로 이체와 동시에 지출결의서 발행이 가능하며, 월단위로 한번에 검색 및 확인이 가능합니다.
								</li>
								<li className="bullet">
									이체 당시 지출결의서 발행이 안되었을 경우, 별도로 지출결의서 발급이 가능하며, 지급처는 거래처정보 및
									사원대장 등록 메뉴에서 등록할 수 있습니다.
								</li>
							</ul>
						</div>
					</div>
				</div>
			</li>
			{/* 인사급여 */}
			<li className="sub-list">
				<div className="function-vod"></div>
				<div className="function-list">
					<div className="function-text">
						<strong className="title">대시보드</strong>
						<div className="intro-desc">
							<ul className="bullet-square">
								<li className="bullet">
									매출/전년동월대비 급여 지급현황을 시각화된 데이터로 제공하며, 공지사항 및 인사관련 세무일정을
									제공합니다.
								</li>
							</ul>
						</div>
					</div>
					<div className="function-text">
						<strong className="title">사원 대장</strong>
						<div className="intro-desc">
							<ul className="bullet-square">
								<li className="bullet">
									소득유형별(근로소득자, 일용직,사업소득자, 기타소득자) 로 사원관리가 가능하도록 기능을 제공하며,
									기본정보를 입력할 수 있습니다.
								</li>
								<li className="bullet">
									사원별 인적사항과 부양가족 정보를 직접 입력할 수 있으며, 연속 등록 기능으로 편의성을 제공합니다.
								</li>
								<li className="bullet">
									급여정보 입력 시 예금주 조회 기능을 통해 정확한 계좌정보를 등록할 수 있으며, 급여계산 시 공제금액이
									자동으로 계산됩니다.
								</li>
								<li className="bullet">
									여러 사원의 일괄등록을 위한 기본 엑셀 템플릿과 업로드 기능을 제공하며, 출력도 가능합니다.
								</li>
							</ul>
						</div>
					</div>
					<div className="function-text">
						<strong className="title">증명서 발급</strong>
						<div className="intro-desc">
							<ul className="bullet-square">
								<li className="bullet">
									사원대장에 등록된 사원의 재직증명서, 경력증명서, 퇴직증명서, 위촉증명서, 해촉증명서 등 각종 증명서
									발급이 가능합니다.
								</li>
								<li className="bullet">
									출력 혹은 문자/메일/카카오톡으로 발송처리가 가능하며, 발송내역을 조회하고 관리할 수 있습니다.
								</li>
							</ul>
						</div>
					</div>
					<div className="function-text">
						<strong className="title">4대보험 신고</strong>
						<div className="intro-desc">
							<ul className="bullet-square">
								<li className="bullet">
									기초정보&gt;외부기관연동 메뉴를 통해 인증서를 연동한 후 별도 사이트 접속 없이 취득/상실/피부양자 신고
									기능 이용이 가능합니다.
								</li>
								<li className="bullet">
									취득(피부양자 포함)/상실 신고 시 이미 등록된 사원대장 내 사원정보를 불러와서 신고를 할 수 있습니다.
								</li>
								<li className="bullet">
									기존 신고 내역 등 민원처리 현황조회는 실시간 조회가 가능하므로 업무 시간이 단축됩니다.
								</li>
							</ul>
						</div>
					</div>
					<div className="function-text">
						<strong className="title">급여관리</strong>
						<div className="intro-desc">
							<ul className="bullet-square">
								<li className="bullet">
									직원들의 지급액(과세, 비과세)을 기반으로 세법에 맞게 공제액을 자동으로 계산할 수 있습니다.
								</li>
								<li className="bullet">
									소득세 감면기간 및 한도 적용, 두루누리 감면에 대해 자동으로 계산하고 관리할 수 있습니다.
								</li>
								<li className="bullet">
									급여 대장을 통해 월별로 지급된 사원 목록과 각 항목별 총 금액을 확인할 수 있습니다.
								</li>
								<li className="bullet">
									직원들에게 발송하는 급여명세서를 자동으로 생성하고 관리할 수 있으며, 문자/메일/카카오톡으로 발송처리가
									가능합니다.
								</li>
								<li className="bullet">
									전표발행/취소 버튼을 클릭하면 입력한 급여 내역에 대해 전표 처리를 할 수 있습니다.
								</li>
							</ul>
						</div>
					</div>
					<div className="function-text">
						<strong className="title">퇴직금 관리</strong>
						<div className="intro-desc">
							<ul className="bullet-square">
								<li className="bullet">
									퇴직금 중간정산 및 퇴직한 직원들의 퇴직정산이 가능하며, 급여입력 메뉴에서 입력된 급여와 상여금 등으로
									각 직원의 퇴직 정산을 할 수 있습니다.
								</li>
								<li className="bullet">
									사원을 선택하면 등록된 사원정보 및 급여대장 정보를 기준으로 퇴직금 및 퇴직소득세를 계산할 수 있습니다.
								</li>
								<li className="bullet">
									퇴직금 계산 시 퇴직소득세 및 기타 공제 금액이 자동으로 계산되며, 중간정산의 경우 이력을 별도로 확인할
									수 있습니다.
								</li>
								<li className="bullet">
									퇴직금 추계액: 매달 말일 기준으로 사원 별로 퇴사 시 지급하여야 할 퇴직금 추계액을 바로 확인할 수
									있습니다.
								</li>
							</ul>
						</div>
					</div>
					<div className="function-text">
						<strong className="title">급여보고서</strong>
						<div className="intro-desc">
							<ul className="bullet-square">
								<li className="bullet">
									연간 급여집계: 사원별 연간 급/상여를 집계하여 조회하며 귀속 년월 기준으로 집계한 내역을 각 항목 별로
									구분하여 보여줍니다. 최대 1년 및 회기중 조회 시 1월 ~ 현재까지 집계되어 조회됩니다.
								</li>
								<li className="bullet">
									지급 항목별 집계: 지급 항목에 따라 사원별/월별 지급 금액을 집계하여 조회하며, 귀속 년월 기준으로
									집계한 내역을 각 항목 별로 구분하여 조회할 수 있으며 파일로 다운로드 가능합니다.
								</li>
								<li className="bullet">
									공제 항목별 집계: 공제 항목에 따라 사원별/월별 지급 금액을 집계하여 조회하며, 귀속 년월 기준으로
									집계한 내역을 각 항목 별로 구분하여 조회할 수 있으며 파일로 다운로드 가능합니다.
								</li>
							</ul>
						</div>
					</div>
				</div>
			</li>
			{/* 재고관리 */}
			<li className="sub-list">
				<div className="function-vod"></div>
				<div className="function-list">
					<div className="function-text">
						<strong className="title">품목관리</strong>
						<div className="intro-desc">
							<ul className="bullet-square">
								<li className="bullet">
									신규 등록 및 기존품목 수정 작업을 엑셀 파일 업로드로 간편하게 처리할 수 있습니다.
								</li>
								<li className="bullet">
									거래처별로 자주 거래하는 품목을 설정하고, 품목별 거래등급을 설정하여 매출 단가와 수량을 별도로 관리할
									수 있습니다.
								</li>
								<li className="bullet">
									품목별로 최근 매입 및 매출 단가를 노출하여, 단가가 자주 변동하는 업종에서도 최신 단가를 미리 확인하고
									쉽게 활용할 수 있습니다.
								</li>
							</ul>
						</div>
					</div>
					<div className="function-text">
						<strong className="title">재고 수불관리</strong>
						<div className="intro-desc">
							<ul className="bullet-square">
								<li className="bullet">
									발주서, 견적서, 수주서를 작성하고 거래처에 전자문서 형태로 보낼 수 있으며 출력물로도제공합니다. 또한
									작성된 문서를 기준으로 입출고 처리를 편리하게 진행할 수 있습니다.
								</li>
								<li className="bullet">
									외화거래 입력 시에는 통화코드 및 환율정보 제공을 통해 편리하게 원화로 환산하여 입력이 가능합니다.
								</li>
								<li className="bullet">
									작성한 문서를 메일, 문자메시지, 카카오톡, 팩스를 통해 거래처에 발송할 수 있으며, 발송 내역을 관리하고
									재발송이 가능합니다.
								</li>
								<li className="bullet">
									재고 수불 흐름을 단계별로 확인할 수 있으며, 품목별, 거래처별, 일자별로 재고 내역을 추적하여 잔여
									재고량을 쉽게 확인할 수 있습니다.
								</li>
								<li className="bullet">발주대비 입고내역을 통해 정확한 주문관리가 가능합니다.</li>
								<li className="bullet">
									창고를 생성하고 품목별 기본창고를 지정할 수 있으며, 창고별 재고량을 조회하고, 다른 창고로 재고를
									이동할 수 있습니다.
								</li>
								<li className="bullet">
									업무 담당자가 분리되어 있을 때도, 한 명의 담당자가 모든 업무를 처리할 때도 유연하게 업무를 처리할 수
									있습니다.
								</li>
							</ul>
						</div>
					</div>
					<div className="function-text">
						<strong className="title">재고 회계연계</strong>
						<div className="intro-desc">
							<ul className="bullet-square">
								<li className="bullet">
									입/출고 처리한 내역을 마감하고 전표처리 할 수 있습니다. 입/출고 데이터와 연동되어 편리하게 전표처리가
									가능합니다.
								</li>
								<li className="bullet">
									매입매출전표를 등록하면서 처리한 품목에 대해 자동으로 입출고 내역에 반영되도록 기초 설정에서 설정할 수
									있어, 사용자의 편리한 이용이 가능합니다.
								</li>
								<li className="bullet">수불 데이터를 기준으로 거래명세서를 발행할 수 있습니다.</li>
							</ul>
						</div>
					</div>
					<div className="function-text">
						<strong className="title">재고자산 관리</strong>
						<div className="intro-desc">
							<ul className="bullet-square">
								<li className="bullet">2가지의 재고평가 방법을 제공합니다. (선입선출법, 이동평균법)</li>
								<li className="bullet">
									입출고 마감, 회기 마감, 재고 평가 마감 기능을 통해 입출고 데이터의 정합성을 보장하며, 정확한 재고
									관리가 가능합니다.
								</li>
								<li className="bullet">
									재고 평가를 기간 단위로 진행하여, 각 기간별로 품목에 대한 재고 자산 금액을 확인하고 효율적으로 관리할
									수 있습니다.
								</li>
							</ul>
						</div>
					</div>
					<div className="function-text">
						<strong className="title">보고서</strong>
						<div className="intro-desc">
							<ul className="bullet-square">
								<li className="bullet">
									이익현황조회: 매출수량과 매출금액, 매출원가로 매출이익을 계산하여 이익률을 조회할 수 있습니다. 기간별
									입/출고 데이터를 기반으로, 품목별, 거래처별, 부서별 등 다양한 조건에 맞춰 매출 이익 현황을 실시간으로
									확인할 수 있습니다.
								</li>
								<li className="bullet">
									사용자가 설정한 적정 재고량을 기준으로, 품목별 현재 재고량과 예상 발주량을 자동으로 계산하여
									제공함으로써 재고 부족 상황을 미리 방지하고 효율적인 재고 관리를 지원합니다.
								</li>
							</ul>
						</div>
					</div>
				</div>
			</li>
			{/* 영업관리 */}
			<li className="sub-list">
				<div className="function-vod"></div>
				<div className="function-list">
					<div className="function-text">
						<strong className="title">견적서</strong>
						<div className="intro-desc">
							<ul className="bullet-square">
								<li className="bullet">
									고객에게 제공할 제품이나 서비스의 예상 단가와 조건을 간편하게 작성하고 발송할 수 있습니다.
								</li>
								<li className="bullet">
									견적서 화면에서 예상 단가와 조건을 그대로 출고하거나 수정하여 출고할 수 있습니다.
								</li>
								<li className="bullet">견적대비 출고내역의 상세 보고서를 제공합니다.</li>
							</ul>
						</div>
					</div>
					<div className="function-text">
						<strong className="title">수주서</strong>
						<div className="intro-desc">
							<ul className="bullet-square">
								<li className="bullet">
									고객으로부터 받은 주문 내용을 간편하게 작성하거나 견적서와 연동하여 작성할 수 있습니다.
								</li>
								<li className="bullet">수주서 화면에서 주문 내용을 그대로 출고하거나 수정하여 출고할 수 있습니다.</li>
								<li className="bullet">수주대비 출고내역의 상세 보고서를 제공합니다.</li>
							</ul>
						</div>
					</div>
				</div>
			</li>
			{/* B2B */}
			<li className="sub-list">
				<div className="function-vod"></div>
				<div className="function-desc">
					<img src={images.b2bDesc} alt="B2B 수발주 플랫폼" />
				</div>
				<div className="function-list">
					<div className="function-text">
						<strong className="title">품목관리</strong>
						<div className="intro-desc">
							<ul className="bullet-square">
								<li className="bullet">B2B 수발주 플랫폼에서 거래할 품목과 거래처를 손쉽게 설정할 수 있습니다.</li>
								<li className="bullet">
									스텔라에 등록된 품목, 거래처, 거래처 전용 품목을 연동하여 별도의 입력 없이 빠르게 B2B 거래 환경을
									구축할 수 있습니다.
								</li>
								<li className="bullet">
									엑셀 파일 업로드로 품목 상세 설명을 쉽게 추가할 수 있어 품목 관리가 간편해집니다.
								</li>
							</ul>
						</div>
					</div>
					<div className="function-text">
						<strong className="title">거래관리</strong>
						<div className="intro-desc">
							<ul className="bullet-square">
								<li className="bullet">
									거래처의 견적 요청에 대한 회신 견적 관리와 거래처 발주 건에 대한 수주 관리 기능을 제공합니다.
								</li>
								<li className="bullet">
									견적 회신부터 수주 확정, 출고 처리, 회계 처리까지 모든 과정을 유기적으로 연동하여 업무처리할 수
									있습니다.
								</li>
								<li className="bullet">
									출고 내역에서는 수주 확정 건을 기준으로 출고 현황을 확인하고, 부분 출고 여부도 간편하게 파악할 수
									있습니다.
								</li>
								<li className="bullet">
									거래처는 앱 설치 없이 모바일웹과 PC웹 모두에서 상품 발주 및 견적 요청 업무를 간편하게 처리할 수
									있습니다.
								</li>
								<li className="bullet">거래처에게 접속 URL 및 계정정보만 전달하시면 됩니다.</li>
							</ul>
						</div>
					</div>
					<div className="function-text">
						<strong className="title">결제관리</strong>
						<div className="intro-desc">
							<ul className="bullet-square">
								<li className="bullet">가상계좌 기반의 즉시결제 또는 후결제 방식을 거래처에 제공할 수 있습니다.</li>
								<li className="bullet">
									가상계좌 신청부터 연동까지 원스톱으로 처리되어 별도 개발 없이도 손쉽게 결제 시스템을 도입할 수
									있습니다.
								</li>
								<li className="bullet">
									수주서와 연동해 대금청구서를 자동 작성 및 발송할 수 있으며, 수기 작성도 지원합니다.
								</li>
								<li className="bullet">
									가상계좌 서비스와 연결하면 결제 방식에 맞춰 간편하게 결제 처리까지 가능합니다.
								</li>
							</ul>
						</div>
					</div>
					<div className="function-text">
						<strong className="title">알림 및 알림 설정</strong>
						<div className="intro-desc">
							<ul className="bullet-square">
								<li className="bullet">
									실시간 알림 기능을 통해 견적, 수주, 결제 등의 진행 상황을 실시간으로 확인할 수 있습니다.
								</li>
								<li className="bullet">
									중요한 업무를 놓치지 않도록 알림 설정을 개인화하여, 필요한 업무에만 알림을 받을 수 있습니다.
								</li>
							</ul>
						</div>
					</div>
				</div>
			</li>
			{/* 장부/결산 */}
			<li className="sub-list">
				<div className="function-vod"></div>
				<div className="function-list">
					<div className="function-text">
						<strong className="title">장부생성</strong>
						<div className="intro-desc">
							<ul className="bullet-square">
								<li className="bullet">
									분개장: 차변과 대변으로 구분하여 계정과목과 금액을 거래발생 순서로 기입하는 장부로 결산전표 자동분개
									기능을 제공합니다.
								</li>
								<li className="bullet">
									총계정원장: 입력된 전표를 계정과목별로 집계한 장부로 전표입력과 동시에 자동 생성되며, 재무재표 작성 시
									기초자료가 됩니다.
								</li>
								<li className="bullet">
									일/월계표, 계정별원장, 거래처원장, 매입매출장, 현급출납장 등 다양한 장부생성이 자동으로 진행되며, 엑셀
									다운로드가 가능합니다.
								</li>
							</ul>
						</div>
					</div>
					<div className="function-text">
						<strong className="title new">결산</strong>
						<div className="intro-desc">
							<ul className="bullet-square">
								<li className="bullet">
									자동으로 반영되는 것 외에 기말재고금액, 감가상각비 및 대손상각비를 사용자가 직접 입력하면 추가적으로
									결산금액에 반영할 수 있습니다.
								</li>
								<li className="bullet">
									계정과목별로 결산 전 금액 조회한 후 결산금액을 반영하시면 예상되는 결산 후 금액을 바로 조회할 수
									있으며, 결산분개발행 기능을 통해 자동으로 전표가 생성됩니다.
								</li>
								<li className="bullet">
									월단위 결산전표 및 익월 차감분개 등의 발행여부 및 발행이력 등 결산이력을 확인할 수 있습니다.
								</li>
								<li className="bullet">
									적격증빙이 아닌 영수증을 수취한 거래 중 건당 3만원을 초과한 거래에 대해 해당 내역을 등록/작성할 수
									있는 영수증수취명세서 기능도 제공합니다.
								</li>
							</ul>
						</div>
					</div>
					<div className="function-text">
						<strong className="title">재무제표</strong>
						<div className="intro-desc">
							<ul className="bullet-square">
								<li className="bullet">
									결산 후 합계잔액시산표, 재무상태표, 손익계산서, 원가명세서 등이 자동 생성되어 손쉽게 금융거래와
									거래결과를 효과적으로 시각화하여 재무거래의 투명성 및 즉각적인 의사결정을 지원합니다.
								</li>
								<li className="bullet">
									이익잉여금처분계산서의 자동생성으로 경영진, 주주, 감사인 등 다양한 이해관계자들에게 회사의 이익에 대한
									투명성을 제공하고 이익잉여금의 효율적인 운용에 대한 정보를 제공하는 등 기업의 금융 건강 상태에 대한
									평가가 가능합니다.
								</li>
							</ul>
						</div>
					</div>
				</div>
			</li>
			{/* 세금신고 */}
			<li className="sub-list">
				<div className="function-vod"></div>
				<div className="function-list">
					<div className="function-text">
						<strong className="title">원천세 신고</strong>
						<div className="intro-desc">
							<ul className="bullet-square">
								<li className="bullet">
									원천세는 모든 원천징수 소득(근로/사업/기타/퇴직)에 대해 부과되는 소득세(국세)와 지방소득세(지방세)를
									의미하며, 해당 소득자의 원천세를 사업자가 지급액에서 먼저 제한 후 국가에 대신 납부하는 제도를
									말합니다.
								</li>
								<li className="bullet">
									스텔라를 이용하면 귀속연월과 지급연월 기준 급여자료에 등록된 각 소득구분별로 자료가 자동으로
									반영되므로 원천세신고 자료인 원천징수이행상황신고서와 간이지급명세서를 간편하게 작성할 수 있습니다.
								</li>
								<li className="bullet">
									신고 후 홈택스 납부서를 다운로드할 수 있으며, 지급월, 신고종류, 신고구분 별 전자신고 파일 제작이
									가능합니다.
								</li>
							</ul>
						</div>
					</div>
					<div className="function-text">
						<strong className="title">부가세 신고</strong>
						<div className="intro-desc">
							<ul className="bullet-square">
								<li className="bullet">스텔라는 홈택스에 직접 신고가 가능하도록 부가세 신고서 생성을 지원합니다.</li>
								<li className="bullet">
									변경되는 세법 및 관련 법규 내용을 수시로 파악하여 실시간 업데이트를 제공합니다.
								</li>
								<li className="bullet">
									일반적인 경우 법인사업자는 1년에 4회/개인사업자는 2회 신고, 간이과세자는 1년을 과세기간으로 하여
									신고·납부하게 됩니다.
								</li>
							</ul>
						</div>
					</div>
					<div className="function-text">
						<strong className="title">부가세 신고서 생성</strong>
						<div className="intro-desc">
							<ul className="bullet-square">
								<li className="bullet">매입매출전표 증빙유형 및 계정과목에 기반하여 부가세 신고서를 생성합니다.</li>
								<li className="bullet">
									예정/확정 신고, 영세율 조기환급, 기한 후 신고 등 다양한 신고 기능을 제공합니다.
								</li>
								<li className="bullet">
									사용자가 직접 작성해야 할 첨부서류는 작성 서식을 제공하여 편리하게 작업이 가능합니다.
								</li>
								<li className="bullet">작성내용 저장, 신고서 마감 기능을 통해 자료변환을 방지합니다.</li>
							</ul>
						</div>
					</div>
					<div className="function-text">
						<strong className="title">주요서류 지원 목록</strong>
						<div className="intro-desc">
							<ul className="bullet-square">
								<li className="bullet">부가가치세신고서(일반과세자 신고서 및 수정신고서)</li>
								<li className="bullet">사업장현황명세서, 부가가치세 납부서</li>
								<li className="bullet">
									매출세금계산서합계표, 매입세금계산서합계표, 매출계산서합계표, 매입계산서합계표, 신용카드매출전표등
									수령명세서, 신용카드매출전표발행금액집계표
								</li>
								<li className="bullet">
									공제받지못할 매입세액명세서, 건물등감가상각자산취득명세서, 대손세액공제(변제)신고서 전자세금계산서
									발급세액공제신고서, 과표수정 및 추가납부계산서(부가세), 과세표준 및 세액경정청구서(부가세) 등
								</li>
							</ul>
						</div>
					</div>
					<div className="function-text">
						<strong className="title">업종별 첨부 서류 지원 목록</strong>
						<div className="intro-desc">
							<ul className="bullet-square">
								<li className="bullet">
									매입자발행세금계산서합계표, 매입자발행계산서합계표, 부동산임대공급가액명세서, 의제매입세액공제신고서,
									재활용폐자원세액공제신고서, 현금매출명세서, 전자화폐결제명세서, 수출실적명세서,
									영세율첨부서류제출명세서, 영세율매출명세서, 내국신용장/구매확인서, 외화획득명세서 등
								</li>
							</ul>
						</div>
					</div>
				</div>
			</li>
			{/* 제증명발급 */}
			<li className="sub-list">
				<div className="function-vod"></div>
				<div className="function-list">
					<div className="function-text">
						<strong className="title">홈택스</strong>
						<div className="intro-desc">
							<ul className="bullet-square">
								<li className="bullet">
									사업자등록증명 등 민원증명서를 사이트 로그인 없이 즉시 발급 및 저장이 가능합니다.
								</li>
								<li className="bullet">
									홈택스에 등록된 인증서로 발급이 가능하며, 신청한 문서는 다운로드 폴더에 저장, 저장된 문서로 출력
									가능합니다.
								</li>
								<li className="bullet">
									사업자등록증명, 납세증명서(국세완납증명), 표준재무제표증명, 부가가치세표준증명,
									부가가치세면세사업자수입금액증명, 납부내역증명(납세사실증명)
								</li>
							</ul>
						</div>
					</div>
					<div className="function-text">
						<strong className="title">대법원</strong>
						<div className="intro-desc">
							<ul className="bullet-square">
								<li className="bullet">
									법인등기부등본, 부동산등기부등본 등 민원증명서를 사이트 로그인 없이 즉시 발급 및 저장이 가능합니다.
								</li>
							</ul>
						</div>
					</div>
					<div className="function-text">
						<strong className="title">정부24</strong>
						<div className="intro-desc">
							<ul className="bullet-square">
								<li className="bullet">
									지방세 납세증명서, 자동차등록원부(갑, 을) 등 민원증명서를 사이트 로그인 없이 즉시 발급 및 저장이
									가능합니다.
								</li>
								<li className="bullet">
									정부24에 등록된 인증서로 발급이 가능하며, 신청한 문서는 다운로드 폴더에 저장, 저장된 문서로 출력
									가능합니다.
								</li>
							</ul>
						</div>
					</div>
				</div>
			</li>
		</ul>
	);
};

export default MainSubContentListBox;
